import { render, staticRenderFns } from "./Artesoes.vue?vue&type=template&id=09ebf879&"
import script from "./Artesoes.vue?vue&type=script&lang=js&"
export * from "./Artesoes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports